import { colors } from '@khaddi/ui';
import { View } from 'react-native';

/** Stylised street map from the delivery artboard; decorative only, the real route opens in Google Maps. */
export const MapIllustration = ({ height = 300 }: { height?: number }) => (
  <View aria-hidden style={{ position: 'absolute', top: 0, left: 0, right: 0, height, backgroundColor: colors.mapBg, overflow: 'hidden' }}>
    <svg width="100%" height={height} viewBox="0 0 390 300" preserveAspectRatio="xMidYMid slice" aria-hidden style={{ display: 'block' }}>
      <rect width="390" height="300" fill={colors.mapBg} />
      <path d="M-10 70 L400 40 M-10 200 L400 220 M60 -10 L100 320 M280 -10 L260 320" stroke="#FFFFFF" strokeWidth="14" />
      <path d="M-10 130 L400 125 M180 -10 L170 320" stroke="#FFFFFF" strokeWidth="22" />
      <rect x="200" y="150" width="50" height="50" rx="6" fill="#CFE5DC" />
      <rect x="110" y="20" width="50" height="40" rx="6" fill="#D3E5EF" />
      <path d="M120 240 C140 190 160 170 175 128 S240 90 320 80" fill="none" stroke={colors.primaryText} strokeWidth="6" strokeLinecap="round" />
      <circle cx="120" cy="240" r="20" fill="#FFFFFF" stroke={colors.primaryText} strokeWidth="3" />
      <g transform="translate(108 228)" fill="none" stroke={colors.primaryText} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="5" cy="17" r="3.5" />
        <circle cx="19" cy="17" r="3.5" />
        <path d="M15 6h3l3 8M5 17 8.5 9h6L18 17" />
      </g>
      <circle cx="320" cy="80" r="16" fill={colors.red} />
      <circle cx="320" cy="80" r="6" fill="#FFFFFF" />
    </svg>
  </View>
);
